import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MailService, Mail } from 'npx-family-happy-common';
import { CertificateService } from 'src/app/services/certificate-service/certificate.service';
import { environment } from 'src/environments/environment';
import { FormService } from '../../services/form-service/form.service';
import { NurseService } from '../../services/nurse-service/nurse.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { ModalLoaderComponent } from 'src/app/shared/components/modal-loader/modal-loader.component';

const EMAIL_TEST = 'colucci.ivan95@gmail.com'; // Cambiamento temporaneo indirizzo email di test

@Component({
  selector: 'app-nurse-certification-test',
  templateUrl: './nurse-certification-test.component.html',
  styleUrls: ['./nurse-certification-test.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ModalLoaderComponent]
})
export class NurseCertificationTestComponent implements OnInit {
  form = new UntypedFormGroup({
    1: new UntypedFormControl('', Validators.required),
    2: new UntypedFormControl('', Validators.required),
    3: new UntypedFormControl('', Validators.required),
    4: new UntypedFormControl('', Validators.required),
    5: new UntypedFormControl('', Validators.required),
    6: new UntypedFormControl('', Validators.required),
    7: new UntypedFormControl('', Validators.required),
    8: new UntypedFormControl('', Validators.required),
    9: new UntypedFormControl('', Validators.required),
    10: new UntypedFormControl('', Validators.required)
  });

  personalInfo = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email])
  });

  modalLoader = false

  rightAnswers = ['B', 'A', 'B', 'A', 'B', 'B', 'C', 'B', 'A', 'B'];
  mistakes: number = 0;
  zapierData = {
    email: '',
    esito: ''
  };

  answers!: Array<string>
  esito = ""

  constructor(private nurseService: NurseService, private mailService: MailService, private certificateService: CertificateService,
    private formService: FormService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.form.valueChanges.subscribe(value => {
      if (this.form.valid) {
        this.mistakes = 0;
        this.answers = Object.values(value);

        this.answers.forEach((answer, i) => {
          if (answer !== this.rightAnswers[i]) {
            this.mistakes++
          }
          if (this.mistakes > 2) {
            this.esito = "fallito"
          } else {
            this.esito = "superato"
          }
        });
      }
    })

    this.personalInfo.valueChanges.subscribe(value => {
      if (this.personalInfo.valid) {
        this.zapierData = {
          email: value.email,
          esito: ''
        };
      }
    })
  }

  submitForm() {
    this.modalLoader = true
    this.nurseService.findNurseByEmail(this.personalInfo.get('email')?.value).subscribe(nurse => {
      let answers = this.createBodyAnswer(this.answers)
      if (!nurse.length) {
        alert('ERRORE: L\'indirizzo email inserito non è associato ad alcuna badante.');
        this.modalLoader = false;
        this.modalService.dismissAll()
      } else {
        let senderEmail = 'servizioclienti@familyhappybenefit.com';
        let senderEmailCert = 'servizioclienti@familyhappybenefit.com';
        let babysitterEmail = environment.production ? this.personalInfo.get('email')?.value : EMAIL_TEST;
        const babysitterName = nurse[0].info.name + nurse[0].info.surname;
        let bodyCertMessage = `<p>Test certificazione del Corso di Sicurezza dell'Anziano,<br>risposte del test:${answers},<br>Esito : ${this.esito}</p>`

        if (this.mistakes > 2) {  /* Nurse did not pass the test. */
          let mailCert = new Mail(senderEmailCert, 'servizioclienti@familyhappybenefit.com', `CERTIFICAZIONI - NURSE - ${babysitterEmail}`, bodyCertMessage, []);
          let courseLink = 'https://familyhappy.lt.acemlnb.com/Prod/link-tracker?notrack=1&notrack=1&redirectUrl=aHR0cHMlM0ElMkYlMkZ3d3cueW91dHViZS5jb20lMkZ3YXRjaCUzRnYlM0R1WW5fOXJmZlkxWSUyNnV0bV9zb3VyY2UlM0RBY3RpdmVDYW1wYWlnbiUyNnV0bV9tZWRpdW0lM0RlbWFpbCUyNnV0bV9jb250ZW50JTNERmFtaWx5JTI1MkJIYXBweSUyQi0lMkJpbml6aWElMkJsYSUyQmNlcnRpZmljYXppb25lJTI2dXRtX2NhbXBhaWduJTNEb25ib2FyZGluZ19jb3Jzb19iYWJ5c2l0dGVy&sig=H5nDbUBuf7DoAhxmR9CiyhMJtAm4qu1qeoHf8AhwswCi&iat=1660983825&a=%7C%7C650661975%7C%7C&account=familyhappy%2Eactivehosted%2Ecom&email=u1oXqn9zbfKm4mDMsA4h3gA3SuMkJhmkGexv49sZvNU%3D&s=14877772e33a8687c3907569b0f9aec1&i=41A86A23A126';
          let message = `<p>Car* ${babysitterName},<br> Purtroppo non hai superato il Test del Corso di Sicurezza dell'Anziano.<br> Ma non temere: puoi seguire nuovamente il corso e rifare il test:
                         <a href="${environment.formBaseURL}/nurse-certification-test">clicca qui per il test di certificazione</a>.</p>
                         <p>A presto e in bocca al lupo,<br> Il Team di Family+Happy</p>`

          //EMAIL RISULTATI A servizioclienti
          this.mailService.sendCustom(environment.baseURL, mailCert).subscribe(() => {
            let mail = new Mail(senderEmail, babysitterEmail, `Esito test del Corso di Sicurezza dell'Anziano`, message, []);
            this.mailService.sendCustom(environment.baseURL, mail).subscribe(() => {
              window.location.href = 'https://babysitter.familyhappy.it/thank-you-disostruzione';
              this.modalLoader = false
              this.modalService.dismissAll()
            });
          });
        } else {  /* Nurse passed the test. */
          let mailCert = new Mail(senderEmailCert, 'servizioclienti@familyhappybenefit.com', `CERTIFICAZIONI - NURSE - ${babysitterEmail}`, bodyCertMessage, []);
          this.mailService.sendCustom(environment.baseURL, mailCert).subscribe(() => {
            this.certificateService.createNurseCertificatePDF(nurse[0], senderEmail).then((res) => {
              this.modalLoader = false
              this.modalService.dismissAll()
            });
          });
        }
      }
    })
  }
  createBodyAnswer(arr: Array<string>) {
    let htmlString = '';
    for (let i = 0; i < arr.length; i++) {
      htmlString += (i + 1) + '-' + arr[i] + '<br>';
    }
    return htmlString;
  }

}
